import { Box, Table } from "@radix-ui/themes";

interface SpreadsheetPreviewProps {
  previewData: string[][] | null;
}

export function SpreadsheetPreview({ previewData }: SpreadsheetPreviewProps) {
  if (!previewData || previewData.length === 0) {
    return null;
  }

  const headers = previewData[0];
  const rows = previewData.slice(1);

  return (
    <Box
      style={{
        overflow: "auto",
        maxWidth: "100%",
        maxHeight: "400px",
      }}
    >
      <Table.Root variant="surface">
        <Table.Header>
          <Table.Row>
            {headers.map((header, index) => (
              <Table.ColumnHeaderCell
                key={index}
                style={{ maxWidth: "300px", minWidth: "150px" }}
              >
                {header}
              </Table.ColumnHeaderCell>
            ))}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {rows.map((row, rowIndex) => (
            <Table.Row key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <Table.Cell
                  key={cellIndex}
                  style={{
                    maxWidth: "300px",
                    minWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {cell}
                </Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
}
